import companyPlanningRecordService from './companyPlanningRecordService'

export default companyPlanningRecordService
